export const METAMAP_SDK_STARTED_EVENT = 'metamapSdkStarted';
export const METAMAP_FLOW_COMPLETED_EVENT = 'metamapFlowCompleted';
export const METAMAP_FLOW_ABANDONED_EVENT = 'metamapFlowAbandoned';
//# sourceMappingURL=definitions.js.map